import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import {FirebaseService} from '../components/firebase-service/firebase-service.service';
import {AnalyticsService} from '../components/analytics-service/analytics.service';

@Component({
  selector: 'app-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss']
})
export class NewsListComponent implements OnInit {
  news: any[];
  gallery: any[];
  dataPath = 'news';

  constructor(private analyticsService: AnalyticsService, private firebaseService: FirebaseService) {
    this.news = [];
    this.gallery = [];
    this.analyticsService.emitEvent(
      'Page visit',
      'News'
    );
  }

  ngOnInit() {
    this.firebaseService.getCollection(this.dataPath).subscribe(res => {
      console.log(res);
      this.news = [];
      this.gallery = [];
      for (const news of res) {
        if (!!news.date) {
          this.news.push(news);
        } else {
          this.gallery.push(news);
        }
      }
      this.news = _.sortBy(this.news, (news) => {
        return (0 - news.date.toDate());
      });
    });

  }

}
